import {
    Box,
    Dialog,
    DialogContent,
    IconButton
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import { ImageCarousel } from "./ImageCarousel";
import { ResolvedImageEntity } from "../../../lib/dashboard/types/ImageEntity";
import { SwiperClass } from "swiper/react";
import { grey } from "@mui/material/colors";
import { isMobile } from "react-device-detect";
import { useState } from "react";

type ExpandableImageCarouselProps = {
    images: Array<ResolvedImageEntity> | undefined;
    showUploadImages?: boolean;
    onUploadImagesClick?: () => void;
};

export const ExpandableCarousel = (props: ExpandableImageCarouselProps) => {
    const { images, showUploadImages = false, onUploadImagesClick } = props;
    const [expanded, setExpanded] = useState<boolean>(false);
    const [thumbnailSwiperInstance, setThumbnailSwiperInstance] = useState<SwiperClass | undefined>(undefined);
    const [fullScreenSwiperInstance, setFullScreenSwiperInstance] = useState<SwiperClass | undefined>(undefined);

    return (
        <>
            <Box height="100%" width="100%" position="relative">
                <ImageCarousel
                    key="thumbnail"
                    images={images}
                    swiper={thumbnailSwiperInstance}
                    onSwiper={setThumbnailSwiperInstance}
                    controller={{ control: fullScreenSwiperInstance }}
                    onClick={() => {
                        setExpanded(true);
                    }}
                    objectFit="cover"
                    variant="thumbnail"
                    showUploadImages={showUploadImages}
                    onUploadImagesClick={onUploadImagesClick}
                />
            </Box >
            <Dialog
                onClose={() => setExpanded(false)}
                open={expanded}
                maxWidth="xl"
                PaperProps={{
                    sx: {
                        height: "100%",
                        padding: 0,
                        display: !expanded ? "none" : undefined
                    }
                }}
                fullWidth
                keepMounted //keep mounted so that the two carousels can be kept in sync
                fullScreen={isMobile}
            >
                <DialogContent
                    sx={{
                        p: 0,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        "& img": {
                            objectFit: 'contain',
                        }
                    }}
                >
                    <IconButton
                        onClick={(e) => setExpanded(false)}
                        sx={{
                            position: 'absolute',
                            right: 16,
                            top: 8,
                            color: grey[500],
                            zIndex: theme => theme.zIndex.tooltip
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <ImageCarousel
                        key="fullScreen"
                        images={images}
                        swiper={fullScreenSwiperInstance}
                        onSwiper={setFullScreenSwiperInstance}
                        controller={{ control: thumbnailSwiperInstance }}
                        zoom={true}
                        objectFit="contain"
                        variant="full"
                    />
                </DialogContent>
            </Dialog>
        </>
    );
};